import { useEffect } from "react";

export const ICONO = "/brand/tierrascore_icono.svg";
export const APP_ICON = "/brand/tierrascore_app_icon.svg";

export function Wordmark({ className = "" }) {
  return <span className={`ts-wordmark ${className}`} data-testid="ts-wordmark"><span className="a">Tierra</span><span className="b">Score</span></span>;
}

export function useFavicon() {
  useEffect(() => {
    const links = [...document.querySelectorAll("link[rel~='icon']")];
    const previos = links.map((l) => [l, l.href, l.type]);
    links.forEach((l) => { l.href = APP_ICON; l.type = "image/svg+xml"; });
    return () => previos.forEach(([l, h, t]) => { l.href = h; l.type = t; });
  }, []);
}
